import { FeatureFlagName } from '@api'

export const isFeatureAvailable = (
  availableFeatures: FeatureFlagName[] | null,
  featureFlagName?: FeatureFlagName,
  /** This is using while availableFeatures are not fetched */
  defaultValue = true,
) => {
  if (!availableFeatures || !featureFlagName) {
    return defaultValue
  }

  return availableFeatures.includes(featureFlagName)
}
